"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Denotes the side of bounding for range-like criteria. Range can be not bounded at all, but if it is bounded then it
 * can be bounded either from left (lower value fixed) or right (upper value fixed).
 * @see AbstractCriterionRange
 */
var RangeBounding;
(function (RangeBounding) {
    RangeBounding[RangeBounding["UPPER"] = 0] = "UPPER";
    RangeBounding[RangeBounding["LOWER"] = 1] = "LOWER";
})(RangeBounding = exports.RangeBounding || (exports.RangeBounding = {}));
//# sourceMappingURL=range-bounding.js.map